import React from 'react';
import { NotificationImportant } from '@styled-icons/material-outlined';
import AppBannerImageSrc from '@assets/images/AppBannerImage.svg?url';
import CarCrashAlternative from '@assets/images/carCrashAlternative.svg';
import AppleStoreSrc from '@assets/images/apple-app-store.svg?url';
import GooglePlaySrc from '@assets/images/google-play-store.svg?url';
import { NAF_APP_STORE_LINKS } from '@lib/constants';
import * as S from './AppBanner.styles';

interface AppBannerProps {
  title?: string;
  subtitle?: string;
  iconText?: string;
  iconTextTwo?: string;
  layout?: 'compact' | 'full';
}

export const AppBanner = ({
  title = 'Full kontroll på bilen i appen',
  subtitle = 'Varsler, bilinfo og oversikt samlet på ett sted',
  iconText = 'Få påminnelse for EU-kontrollen din i appen',
  iconTextTwo = 'Se status og varsler for din bil',
  layout = 'compact',
}: AppBannerProps) => (
  <S.AppBannerWrapper $isFullWidth={layout === 'full'}>
    <S.AppImageWrapper $isFullWidth={layout === 'full'}>
      <S.PhoneImage $isFullWidth={layout === 'full'} src={AppBannerImageSrc} alt="NAF Appen" aria-hidden="true" />
    </S.AppImageWrapper>
    <S.AppContentWrapper>
      <S.Title variant="headlineXS">{title}</S.Title>
      <S.SubTitle variant="textXLRegular">{subtitle}</S.SubTitle>
      <S.IconTextWrapper>
        <S.IconTextRow>
          <NotificationImportant size={24} />
          <S.IconText variant="textMRegular">{iconText}</S.IconText>
        </S.IconTextRow>
        <S.IconTextRow>
          <CarCrashAlternative aria-hidden="true" />
          <S.IconText variant="textMRegular">{iconTextTwo}</S.IconText>
        </S.IconTextRow>
      </S.IconTextWrapper>
    </S.AppContentWrapper>
    <S.StoreLinks>
      <S.StoreLink href={NAF_APP_STORE_LINKS.ios} target="_blank" rel="noopener noreferrer">
        <S.StoreImage src={AppleStoreSrc} alt="Last ned på App Store" />
      </S.StoreLink>
      <S.StoreLink href={NAF_APP_STORE_LINKS.android} target="_blank" rel="noopener noreferrer">
        <S.StoreImage src={GooglePlaySrc} alt="Last ned på Google Play" />
      </S.StoreLink>
    </S.StoreLinks>
  </S.AppBannerWrapper>
);
